import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getModuleData } from '../../../../selectors/modules';
import { getProfileOwnerUser } from '../../../../selectors/users';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { Props } from './ExhibitionistBox';

type StateProps = Pick<
  Props,
  | 'streamId'
  | 'title'
  | 'seeAllUrl'
  | 'hasMore'
  | 'deviations'
  | 'isEmpty'
  | 'profileOwnerUser'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleData = getModuleData(state, ownProps.moduleId);
  const {
    title,
    hasMore,
    seeAllUrl,
    deviations: deviationIds = [],
  } = moduleData;

  return {
    streamId: `exhibitionist-${ownProps.moduleId}`,
    title,
    seeAllUrl,
    hasMore,
    deviations: getDeviationsByIds(state, deviationIds).filter(
      deviation => deviation
    ),
    isEmpty: !deviationIds.length,
    profileOwnerUser: getProfileOwnerUser(state),
  };
};

export default connect(mapStateToProps);
